export const DEFINED_PERMISSIONS = {
  VendorCreate: "VendorCreate",
  AssetView: "AssetView",
  //=========================================
  Request_Asset: "Request_Asset",
  Vendor: "Vendor",
  SeniorVendorManager: "SeniorVendorManager",
  PrimaryVendorManager: "PrimaryVendorManager",
  ProcurementApproval: "ProcurementApproval",
  ProcurementRequisitionApproval: "ProcurementRequisitionApproval",
  QuotationApproval: "QuotationApprove",
  VendorManager: "VendorManager",
  VendorApproval: "VendorApproval",
  AssetAdd: "AssetAdd",
  AssetApproval: "AssetApproval",
  Auditor: "Auditor",
  PermissionManager: "PermissionManager",
  SecondaryVendorManager: "SecondaryVendorManager",
  UserCreation: "UserCreation",
  AssetAcquisitionView: "AssetAcquisitionView",
  AssetAcquisitionAdd: "AssetAcquisitionAdd",
  AssetAcquisitionApprove: "AssetAcquisitionApprove",
  AssetAllocationAdd: "AssetAllocationAdd",
  AssetAllocationApprove: "AssetAllocationApprove",
  AssetAllocationView: "AssetAllocationView",
  AssetAuctionApprove: "AssetAuctionApprove",
  AssetAuctionAdd: "AssetAuctionAdd",
  AssetAuctionView: "AssetAuctionView",
  AssetBidView: "AssetBidView",
  AssetBidAdd: "AssetBidAdd",
  AssetBidApprove: "AssetBidApprove",
  AssetCategoryAdd: "AssetCategoryAdd",
  AssetCategoryApprove: "AssetCategoryApprove",
  AssetCategoryView: "AssetCategoryView",
  AssetComponentAdd: "AssetComponentAdd",
  AssetComponentView: "AssetComponentView",
  AssetMantainanceView: "AssetMantainanceView",
  AssetMaintainanceApproval: "AssetMaintainanceApproval",
  AssetMantainanceAdd: "AssetMantainanceAdd",
  AssetRequisitionApprove: "AssetRequisitionApprove",
  AssetRequisitionAdd: "AssetRequisitionAdd",
  AssetRequisitionView: "AssetRequisitionView",
  BudgetAdd: "BudgetAdd",
  BudgetView: "BudgetView",
  ConsumableView: "ConsumableView",
  ConsumableApprove: "ConsumableApprove",
  ConsumableAdd: "ConsumableAdd",
  ConsumableAllocationApprove: "ConsumableAllocationApprove",
  ConsumableAllocationAdd: "ConsumableAllocationAdd",
  ConsumableAllocationView: "ConsumableAllocationView",
  ConsumableRequisitionView: "ConsumableRequisitionView",
  ConsumableRequisitionApprove: "ConsumableRequisitionApprove",
  ConsumableRequisitionAdd: "ConsumableRequisitionAdd",
  ConsumableCategoryView: "ConsumableCategoryView",
  ConsumableCategoryApprove: "ConsumableCategoryView",
  ConsumableCategoryAdd: "ConsumableCategoryAdd",
  BusinessNature: "BusinessNature",
  SeniorProcurementManager: "SeniorProcurementManager",
  PrimaryProcurementManager: "PrimaryProcurementManager",
  ProcurementRequisitionView: "ProcurementRequisitionView",
  ProcurementRequisitionAdd: "ProcurementRequisitionAdd",
  ProcurementRequisitionDashboard: "ProcurementRequisitionDashboard",
  QuotationDeliver: "QuotationDeliver",
  // QuotationView: "QuotationView",
  QuotationAdd: "QuotationAdd",
  DeliveryView: "DeliveryView",
  DeliveryApprove: "DeliveryApprove",
  DeliveryConfirm: "DeliveryConfirm",
  DeliveryRating: "DeliveryRating",
  AddDeliveryNote: "AddDeliveryNote",
  ServiceApprove: "ServiceApprove",
  Performance: "Performance",
  PerformanceAdd: "PerformanceAdd",
  PerformanceAppraisal: "PerformanceAppraisal",
  HODApprove: "HODApprove",
  ViewReports: "Report",
  AddReports: "ReportAdd",
  InternalControl: "InternalControl",
};
